export const PAYMENT_METHOD_STORAGE_KEY = 'payment_method';
export const BOOKING_STORAGE_KEY = 'booking';
export const END_USER_REGISTERED_KEY = 'eur';
/** Aidaptive / GA cohort from `registerEndUser` (session cookie, client-set). */
export const AIDAPTIVE_COHORT_KEY = 'ac';
/** sessionStorage key prefix for state we need after a BNPL off-site redirect. */
export const BNPL_REDIRECT_STATE_KEY_PREFIX = 'bnpl_redirect_state:';
/** sessionStorage key prefix for reservation-scoped checkout UI selections. */
export const BOOKING_SELECTIONS_KEY_PREFIX = 'booking_selections:';
